import { UserType } from '../../entities';
import { MobileTechniciansSecurityRight, PortalContractorSecurityRight } from '../modules';
import { AppSecurityRight } from '../modules/app.security';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class SubcontractorAdministrator implements SecurityRole {

    _id = 'bd4e1fe0-5409-4aa4-8640-d05272f32f73';
    system = true;
    hidden = false;
    type = UserType.Subcontractor;
    name = SecurityRoleType.SubcontractorAdministrator;
    description = 'Access to operation dashboard and users, Can use the mobile app to update progress of jobs. These users work for 3rd party subcontractors.';
    rights = [
        AppSecurityRight.LoginContractor,
        AppSecurityRight.LoginField,
        MobileTechniciansSecurityRight.CanAccessJobs,
        MobileTechniciansSecurityRight.ManageJobManageAssets,
        PortalContractorSecurityRight.CanAccessJobs,
        PortalContractorSecurityRight.ManageUsers,
        PortalContractorSecurityRight.ManageCompliance,
        PortalContractorSecurityRight.CanKnowledgeBase,
        PortalContractorSecurityRight.AccessIncomingClaims,
        PortalContractorSecurityRight.ManageIncomingClaims,
        MobileTechniciansSecurityRight.CanAccessTimesheets,
        MobileTechniciansSecurityRight.AllowEditBeforeCheckIn,
        PortalContractorSecurityRight.ModifyFormAfterSubmission,
    ];

}

